
import "./MainMenuPage.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context";
import { getAllUsers } from "../../api";
import { localUrl } from "../../constants";
import Header from "../../Components/Header/Header";
import billing from '../../Assets/MainMenuImages/billing.png';
import flyer from '../../Assets/MainMenuImages/flyer.png';
import video from '../../Assets/MainMenuImages/video.png';
import cover from '../../Assets/MainMenuImages/cover.png';
import qr from '../../Assets/MainMenuImages/qr.png';
import linkedin from '../../Assets/MainMenuImages/linkedin.png';
import meta from '../../Assets/MainMenuImages/meta.png';
import autopost from '../../Assets/MainMenuImages/autopost.png';
import adcampaign from '../../Assets/MainMenuImages/adcampaign.png';
import jotform from '../../Assets/MainMenuImages/jotform.png';
import lead from '../../Assets/MainMenuImages/leads.png';
import sales from '../../Assets/MainMenuImages/sales.png';
import complaints from '../../Assets/MainMenuImages/complaints.png';
import forms from '../../Assets/MainMenuImages/forms.png';
import timekeeper from '../../Assets/MainMenuImages/timekeeper.png';
import ssltracker from '../../Assets/MainMenuImages/ssltracker.png';
import articleGeneration from '../../Assets/MainMenuImages/articleGeneration.png';
import commissionHub from '../../Assets/MainMenuImages/commissionHub.png';
import voiceCampaign from '../../Assets/MainMenuImages/voiceCampaign.png';

function MainMenuPage() {

    const {
        findRole
    } = useGlobalContext()

    const [clientId] = useState<string | undefined>(localStorage.getItem("clientId") as string);

    const navigate = useNavigate();

    const gettingUsersData = async () => {
        try {
            await getAllUsers();
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        gettingUsersData().then(r => r);
    }, [])

    const goToBilling = () => {
        navigate("/billing-clients");
    }

    const goToFlyerMaker = () => {
        window.location.assign(`https://nargona.com:8088/listing/allClients/${clientId}`);
    }

    const goToQRC = () => {
        window.location.assign(`https://nargona.com:8086`);
    }

    const goToLinkedinPost = () => {
        window.location.assign(`https://nargona.com:8086/linked-in/all/${clientId}`);
    }

    const goToVideoMaker = () => {
        window.name = localStorage.getItem("tkn") as string;
        window.open(`${localUrl}:4000`, "_self");
    }

    const goToMetaPost = () => {
        window.location.assign(`https://nargona.com:8087/meta/all/${clientId}`);
    }

    const goToAutoPosting = () => {
        window.name = `${clientId}`;
        window.location.assign(`https://autoposting.nargona.com`);
    }

    const goToAdCampaign = () => {
        window.location.assign(`https://nargona.com:8084/${clientId}`)
    }

    const goToJotform = () => {
        window.location.assign(`https://nargona.com:8082`);
    }

    const goToLeadCenter = () => {
        window.location.assign(` https://nargona.com:8092/login/${clientId}`);
    }

    const goToSales = () => {
        window.location.assign(` https://nargona.com:8080/login/${clientId}`);
    }

    const goToComplaints = () => {
        window.location.assign(`https://nargona.com:8093/login/${clientId}`);
    }

    const goToFormMaker = () => {
        window.name = `${clientId}`;
        window.location.assign(`https://mbsform.com`);
    }

    const goToTimeKeeper = () => {
        window.name = `${clientId}`;
        window.location.assign(`https://cico.nargona.com`);
    }

    const goToSSlTracker = () => {
        window.name = `${clientId}`;
        window.location.assign(`https://ssl.nargona.com`);
    }

    const goToLgt = () => {
        window.name = `${clientId}`;
        window.location.assign(`https://lgt.proconstructcrm.com`);
    }

    const goToCommissionHub = () => {
        window.name = `${clientId}`;
        window.location.assign(`https://nargona.com:8092`);
    }
    const goToArticleGeneration = () => {
        window.name = `${clientId}`;
        window.location.assign(`https://prorecrm.com:8082/${clientId}`);
    }
    const goToVoiceCampaign = () => {
        window.name = `${clientId}`;
        window.location.assign(`https://prorecrm.com:8091`);
    }

    return (
        <div className = "MainMenuPage">
            <Header/>
            <div className = "main-menu-container">
                <div className = 'main-menu-titles-box'>
                    Billing & Sales
                </div>
                {
                    findRole("BS") &&
                        <div className = "main-menu-box" onClick = { goToBilling }>
                            <img src = { billing } className="main-menu-image"  alt = 'nkar'/>
                            Billing <br/> Sheet
                        </div>
                }
                {
                    findRole("LC") &&
                        <div className = "main-menu-box" onClick = { goToLeadCenter }>
                            <img src = {lead} className="main-menu-image"  alt = 'nkar'/>
                            Lead <br/> Center
                        </div>
                }
                {
                    findRole("SS") &&
                        <div className = "main-menu-box" onClick = { goToSales }>
                            <img src = { sales } className="main-menu-image"  alt = 'nkar'/>
                            Sales <br/> Sheet
                        </div>
                }
                {
                    findRole("LCT") &&
                        <div className = "main-menu-box" onClick = { goToLgt }>
                            <img src = { lead } className="main-menu-image"  alt = 'nkar'/>
                            Lead <br/> Generation <br/> Center
                        </div>
                }
                {
                    findRole("CH") &&
                        <div className = "main-menu-box" onClick = { goToCommissionHub }>
                            <img src = { commissionHub } className="main-menu-image"  alt = 'nkar'/>
                            Commision <br/> Hub
                        </div>
                }
                {
                    findRole("VC") &&
                        <div className = "main-menu-box" onClick = { goToVoiceCampaign }>
                            <img src = { voiceCampaign } className="main-menu-image"  alt = 'nkar'/>
                            Voice <br/> Campaign
                        </div>
                }
                <div className = 'main-menu-titles-box'>
                    Design & Content
                </div>
                <div className = "main-menu-box" onClick = { goToFlyerMaker }>
                    <img src = { flyer } className="main-menu-image"  alt = 'nkar'/>
                    Flyer <br/> Maker
                </div>
                {
                    findRole("AG") &&
                    <div className = "main-menu-box" onClick = { goToArticleGeneration }>
                        <img src = { articleGeneration } className="main-menu-image"  alt = 'nkar'/>
                        Article <br/> Generation
                    </div>
                }

                {
                    findRole("VM") &&
                        <div className = "main-menu-box" onClick = { goToVideoMaker }>
                            <img src = { video } className="main-menu-image"  alt = 'nkar'/>
                            Video <br/> Maker
                        </div>
                }
                <div className = "main-menu-box">
                    <img src = { cover } className="main-menu-image"  alt = 'nkar'/>
                    Cover <br/> Maker
                </div>
                <div className = "main-menu-box" onClick = { goToQRC }>
                    <img src = { qr } className="main-menu-image"  alt = 'nkar'/>
                    QR <br/>
                    Code
                </div>
                <div className = 'main-menu-titles-box'>
                    Postings
                </div>
                {
                    findRole("AP") &&
                        <div className = "main-menu-box" onClick = { goToAutoPosting }>
                            <img src = { autopost } className="main-menu-image"  alt = 'nkar'/>
                            Auto <br/> Posting
                        </div>
                }

                {
                    findRole("MP") &&
                        <div className = "main-menu-box" onClick = { goToMetaPost }>
                            <img src = { meta } className="main-menu-image"  alt = 'nkar'/>
                            Meta <br/>Posting
                        </div>
                }
                {
                    findRole("IN") &&
                        <div className = "main-menu-box" onClick = { goToLinkedinPost }>
                            <img src = { linkedin } className="main-menu-image"  alt = 'nkar'/>
                            Linkedin <br/> Posts
                        </div>
                }
                <div className = 'main-menu-titles-box'>
                    Management
                </div>
                {
                    findRole("AC") &&
                        <div className = "main-menu-box" onClick = { goToAdCampaign }>
                            <img src = { adcampaign } className="main-menu-image"  alt = 'nkar'/>
                            Ad <br/> Campaign
                        </div>
                }
                {
                    findRole("JF") &&
                        <div className = "main-menu-box" onClick = { goToJotform }>
                            <img src = { jotform } className="main-menu-image"  alt = 'nkar'/>
                            Jotform <br/> Reports
                        </div>
                }
                {
                    findRole("CS") &&
                        <div className = "main-menu-box" onClick = { goToComplaints }>
                            <img src = { complaints } className="main-menu-image"  alt = 'nkar'/>
                            Complaints <br/> Sheet
                        </div>
                }
                {
                    findRole("GF") &&
                        <div className = "main-menu-box" onClick = { goToFormMaker }>
                            <img src = { forms } className="main-menu-image"  alt = 'nkar'/>
                            Generic <br/> Forms
                        </div>
                }
                {
                    findRole("TK") &&
                        <div className = "main-menu-box" onClick = { goToTimeKeeper }>
                            <img src = { timekeeper } className="main-menu-image"  alt = 'nkar'/>
                            Time <br/> Keeper
                        </div>
                }
                {
                    findRole("ST") &&
                        <div className = "main-menu-box" onClick = { goToSSlTracker }>
                            <img src = { ssltracker } className="main-menu-image"  alt = 'nkar'/>
                            SSL <br/> Tracker
                        </div>
                }
            </div>
        </div>
    )
}

export default MainMenuPage
